import { render, staticRenderFns } from "./AssignManagerTable.vue?vue&type=template&id=47fb6ad7"
import script from "./AssignManagerTable.vue?vue&type=script&lang=js"
export * from "./AssignManagerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports